import { Burger, Button, Group, Skeleton, Stack, Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import classes from './Header.module.css'
import { useUserInfo } from '../api/user'
import { useCallback } from 'react'
import axios from 'axios'

export function Header() {
  const [opened, { toggle }] = useDisclosure(false)

  const handleSignInRedirect = () => {
    const currentPath = encodeURIComponent(window.location.pathname)
    window.location.href = `/admin/login/?next=${currentPath}`
  }

  const {
    data: user,
    isPending: userPending,
    isError: userError,
  } = useUserInfo()

  const logout = useCallback(async () => {
    let resp = await axios.post('/admin/api/logout/')
    if (resp.status === 200) {
      window.location.href = '/admin/login/?next=/'
    }
  }, [])

  return (
    <header className={classes.header}>
      <div className={classes.inner}>
        <Group gap={5} visibleFrom="sm">
          {userPending ? (
            <Skeleton width={100} height={25} />
          ) : userError ? (
            <Button
              variant="outline"
              style={{ backgroundColor: 'white' }}
              onClick={handleSignInRedirect}
            >
              Sign in
            </Button>
          ) : (
            <Group>
              <Text c="white">
                {!!user.first_name
                  ? `${user.first_name} ${user.last_name}`
                  : user?.username}
              </Text>
              <Button variant="subtle" onClick={logout} c="white">
                Log out
              </Button>
            </Group>
          )}
        </Group>
        <Burger opened={opened} onClick={toggle} size="sm" hiddenFrom="sm" />
        {opened && (
          <div className={classes.mobileMenu}>
            <Stack align="center">
              <Button onClick={handleSignInRedirect}>Sign in</Button>
            </Stack>
          </div>
        )}
      </div>
    </header>
  )
}
